export const VERIFY_EMAIL_SETTINGS_ACTION = "VERIFY_EMAIL_SETTINGS_ACTION";
export const VERIFY_OTP_SETTINGS_ACTION = 'VERIFY_OTP_SETTINGS_ACTION'
export const SEND_OTP_SETTING_ACTION = "SEND_OTP_SETTING_ACTION";
export const GET_PROFILE_SETTING_ACTION = "GET_PROFILE_SETTING_ACTION";

